import InventoryLog from "../../components/InventoryLog/InventoryLog";

const InventoryLogPage = () => {
  return <InventoryLog />;
};

export default InventoryLogPage;
